module.exports = "<div\n  v-if=\"_dev\"\n  class=\"drzzle-data-option\"\n  :class=\"{ 'drzzle-data-staging': useStaging }\"\n  @click.prevent=\"toggleFetch\">\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/global-view/fetch-origin/template.html
// module id = fCYX
// module chunks = 0